import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Icon, { ICON_NAMES } from 'components/Icon';


const Container = props => {
  if (props.href)
    return (
      <a
        {...props}
        target='_blank'
        rel='noopener noreferrer'>{props.children}</a>
    )

  if (props.to)
    return (
      <Link {...props}>
      </Link>
    )

  return (
    <button
      {...props}
      type={props.type || 'button'}>
    </button>
  )
}

class CategoryLink extends Component {
  render() {
    const { children, to, onClick, fullCardLink } = this.props;
    const attr = { to, onClick };

    if (fullCardLink)
      return (
        <Container
          className="category-link"
          {...attr}>
          <div className="category-link-container">
            <div className="content-block">
              {children}
            </div>
            <div className="text-center">
              <Icon
                name={ICON_NAMES.visit}
                className="category-link__icon" />
            </div>
          </div>
        </Container>
      )

    return (
      <div
        className="category-link">
        <div className="category-link-container">
          <div className="content-block">
            {children}
          </div>
          <div className="text-center">
            <Container
              {...attr}>
              <Icon
                name={ICON_NAMES.visit}
                className="category-link__icon" />
            </Container>
          </div>
        </div>
      </div>
    )
  }
}

CategoryLink.propTypes = {
  fullCardLink: PropTypes.bool,
};

CategoryLink.defaultProps = {
  fullCardLink: true,
};

export default CategoryLink;